import {Icon} from "Core/Icon/Icon";

export class LookupFieldTable {
    Id: number;
    Name: string;
}